<template>
  <div>
    <a-modal v-model="visible" title="首页设置" :footer="null">
      <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 12 }">
        <a-form-item label="待办模块">
          <a-radio-group v-model="setting.one[0]">
            <a-radio :value="1"> 显示 </a-radio>
            <a-radio :value="0"> 不显示 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="我的申请">
          <a-radio-group v-model="setting.one[1]">
            <a-radio :value="1"> 显示 </a-radio>
            <a-radio :value="0"> 不显示 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="我的应用">
          <a-radio-group v-model="setting.two[0]">
            <a-radio :value="1"> 显示 </a-radio>
            <a-radio :value="0"> 不显示 </a-radio>
          </a-radio-group>
        </a-form-item>
        <!-- <a-form-item label="全部应用">
          <a-radio-group v-model="setting.two[1]">
            <a-radio :value="1"> 显示 </a-radio>
            <a-radio :value="0"> 不显示 </a-radio>
          </a-radio-group>
        </a-form-item> -->
        <a-form-item label="通知模块">
          <a-radio-group v-model="setting.three[0]">
            <a-radio :value="1"> 显示 </a-radio>
            <a-radio :value="0"> 不显示 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="发文模块">
          <a-radio-group v-model="setting.three[1]">
            <a-radio :value="1"> 显示 </a-radio>
            <a-radio :value="0"> 不显示 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="日历日程">
          <a-radio-group v-model="setting.four[0]">
            <a-radio :value="1"> 显示 </a-radio>
            <a-radio :value="0"> 不显示 </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 14, offset: 5 }">
          <a-button type="primary" @click="save"> 保存设置 </a-button>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { addMyCustomModular, queryMyCustomModular } from '@api/api'
export default {
  data() {
    return {
      setting: {
        one: [1, 1],
        // two: [1, 1],
        two: [1],
        three: [1, 1],
        four: [1],
      },
      visible: false,
    }
  },
  created() {
    this.queryMyCustomModular()
  },
  methods: {
    // 查询我的模块设置
    queryMyCustomModular() {
      queryMyCustomModular().then((res) => {
        if (res.success) {
          // this.$bus.$emit('isShow', res.result.pattern)
          this.setting = {
            one: [res.result.dbmk, res.result.wdsq],
            // two: [res.result.wdyy, res.result.qbyy],
            two: [res.result.wdyy],
            three: [res.result.tzmk, res.result.fwmk],
            four: [res.result.rlrc],
          }
          this.$bus.$emit('iSave', JSON.parse(JSON.stringify(this.setting)))
        }
      })
    },
    // 保存我的模块设置
    addMyCustomModular(params) {
      addMyCustomModular(params).then((res) => {
        if (res.success) {
          console.log(res)
          this.queryMyCustomModular()
        }
      })
    },
    save() {
      this.visible = false
      const params = {
        dbmk: this.setting.one[0],
        wdsq: this.setting.one[1],
        wdyy: this.setting.two[0],
        // qbyy: this.setting.two[1],
        tzmk: this.setting.three[0],
        fwmk: this.setting.three[1],
        rlrc: this.setting.four[0],
      }
      this.addMyCustomModular(params)
    },
  },
}
</script>

<style lang="less" scoped>
.ant-form-item{
  text-align: center;
}
</style>